<!-- Общая связанная запись для карточек и форм, просмотр не закрывает текущую форму -->
<template>
  <BaseRelatedRecordCard :title="title" :subtitle="subtitle"
    :icon="resource === 'repairs' ? 'wrench' : 'comment'" :to="recordRoute"
    :view-title="viewLabel" :remove-title="'Убрать связь с ' + entityLabel"
    :removable="removable" :disabled="disabled" @remove="$emit('remove')" />
</template>

<script>
import { useFleetRepairStore } from "@/stores/fleetRepairStore";
import remarkFilters from "@/config/filters/vehicle/remarks.json";

const remarkStatuses = remarkFilters.find((field) => field.value === "status").options;

export default {
  name: "FleetRepairRemarkCard",
  props: {
    record: { type: Object, required: true },
    resource: { type: String, required: true },
    vehicleId: { type: [Number, String], default: null },
    removable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ["remove"],
  computed: {
    title() {
      return (this.resource === "repairs" ? this.record.title : this.record.name || this.record.text)
        || (this.resource === "repairs" ? "Ремонт" : "Пометка");
    },
    entityLabel() {
      return (this.resource === "repairs" ? "ремонтом №" : "пометкой №") + this.record.id;
    },
    viewLabel() {
      return "Открыть " + (this.resource === "repairs" ? "ремонт №" : "пометку №") + this.record.id + " в новой вкладке";
    },
    subtitle() {
      const status = this.resource === "repairs"
        ? (this.record.status ? useFleetRepairStore().formatStatus(this.record.status) : null)
        : remarkStatuses.find((item) => item.value === this.record.status)?.label;
      return ["№" + this.record.id, status, this.record.archived_at ? "В архиве" : null].filter(Boolean).join(" · ");
    },
    recordRoute() {
      return {
        name: "VehicleDetails",
        params: { id: this.vehicleId || this.record.vehicle_id },
        query: this.resource === "repairs"
          ? { tab: "repairs", repair_id: this.record.id }
          : { tab: "remarks", remark_id: this.record.id },
      };
    },
  },
};
</script>

